import { EXPLORER_MEMBERSHIPS_ACTIVE } from "@app/shared/constants";
import { MembershipBillingChoice } from "@app/shared/types";
import { useLocation } from "react-router";

const cycles: { [key: string]: string } = {
    explorerMonthly: "month",
    explorerAnnual: "year",
};

export const isUserInFreeTrialSession = () => {
    return localStorage.getItem("isFreeTrial") === "true" && !localStorage.getItem("cohort");
};

export const getCurrentCohort = () => {
    return localStorage.getItem("cohort");
};

type LocationType = ReturnType<typeof useLocation>;

export const isUserInSetupFlow = (location: LocationType) => {
    return location.pathname.startsWith("/member/setup/");
};

export const isUserOutsideOfMemberZone = (location: LocationType) => {
    return !location.pathname.startsWith("/member");
};

export const getSignupAnalyticsMetadataFromPlanName = (planName: string | undefined) => {
    return {
        planName,
        cycle: planName ? cycles[planName] : undefined,
        membershipType: "explorer",
        preLaunchSignup: !EXPLORER_MEMBERSHIPS_ACTIVE,
        isFreeTrial: isUserInFreeTrialSession(),
        cohort: getCurrentCohort(),
    };
};

export const getSignupAnalyticsMetadataFromPlan = (billingChoice: MembershipBillingChoice) => {
    return {
        ...billingChoice.plan,
        donationAmount: billingChoice.donationAmount,
        preLaunchSignup: !EXPLORER_MEMBERSHIPS_ACTIVE,
        isFreeTrial: isUserInFreeTrialSession(),
        cohort: getCurrentCohort(),
    };
};
